import button from '../button/button'

export default function(o, isPlaying, onChange){

  var getLabel = function(){
    if(isPlaying){
      var label =
        o.util.getTranslation(o, 'pause')
    } else {
      var label =
        o.util.getTranslation(o, 'play')
    }
    return label
  }

  var label = getLabel()

  var getIcon = function(){
    if(isPlaying){
      var icon = 'stop'
    } else {
      var icon = 'play'
    }
    return icon
  }

  var icon = getIcon()

  var toggle = function(){
    if(isPlaying){
      isPlaying = false
    } else {
      isPlaying = true
    }
    div.setLabel(getLabel())
    div.setIcon(getIcon())
    onChange(isPlaying)
  }

  var div =
    button(o, label, toggle, icon, true)

  div.toggle = toggle

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/play/play.js